import { useControlStore } from '@editorStores'

/**
 * Whether a 2D view currently owns the canvas — a selected storey (floorplan) or an orthographic
 * draw/edit tool. The 3D model is hidden while it is true.
 *
 * Derived on read rather than stored: a `modelStore.invisible` flag that components pushed to had
 * to be kept in sync by mount/unmount effects, and whichever component unmounted last clobbered
 * the state of whatever was still active (leaving Structural Planning with a storey selected used
 * to reveal the 3D model while the camera stayed orthographic).
 */
const useFloorplanViewActive = (): boolean => {
  const storey = useControlStore(state => state.floorplanState.storey)
  const orthographicDrawMode = useControlStore(state => state.orthographicDrawMode)

  return !!storey || orthographicDrawMode
}

export default useFloorplanViewActive
